export default {
    'invoice-no': 'Número de factura',
    new: 'Nuevo',
    delete: 'Eliminar',
    account: 'Cuenta',
    'invoice-date': 'Fecha de factura',
    warehouse: 'Almacén',
    document: 'Ref. doc.',
    'net-invoice': 'Gran cantidad',
    edit: 'Editar',
    save: 'Guardar',
    not: 'No',
    posted: 'Publicado',
    'add-invoice': 'Añadir factura',
    notes: 'Notas',
    create: 'Crear',
    cancel: 'Cancelar',

    'delete-entry': 'Eliminar artículo',
    'are-you-sure-you-want-to-delete-the-entry': '¿Estas seguro de eliminar artículo?',
    
    'delete-invoice': 'Eliminar factura',
    'are-you-sure-you-want-to-delete-the-invoice-that-will-delete-the-associated-bond': '¿Está seguro de eliminar la factura, el bono asociado también se eliminará?',
    discount: 'Descuento',
    total: 'Total',

    headers: {
        no: 'Serial',
        warehouse: 'Almacén',
        material: 'Artículo',
        quantity: 'Cantidad',
        count: 'Conteo',
        price: 'Precio',
        'total-amount': 'Valor neto',
        'notes': 'Notas',
        'delivery-status': 'Estado de entrega'
    },

    'context-menu': {
        edit: 'Editar',
        delete: 'Eliminar'
    },
    payments: 'Pagos',
    'total-payments': 'Pagos totales',
    'alert-message': 'Mensaje de alerta',
    'confirm-message': 'Los ingresos totales se han vuelto mayores que el total. ¿Quieres continuar?',
    'total-expenses': 'Gastos totales',
    'expenses': 'Gastos'
}